import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useUserByLicensedProductsQuery, {
	type useUserByLicensedProductsQuery$data,
	type useUserByLicensedProductsQuery$variables,
} from './__generated__/useUserByLicensedProductsQuery.graphql.ts';

export const preloadGetLicensedProductsQuery = () => {
	return query<useUserByLicensedProductsQuery$data, useUserByLicensedProductsQuery$variables>({
		query: useUserByLicensedProductsQuery,
	});
};
